export default {"src":"/_next/static/media/carDetailHashtagIcon.38e171ca.svg","height":28,"width":28};